export default {
  root: {
    width: 22,
    height: 22,
  },
};
